module.exports = require("rxjs/observable/merge");